var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SaaSLayout',{ref:"layout",attrs:{"menus":_vm.menusPre}})
}
var staticRenderFns = []

export { render, staticRenderFns }